import styled from 'styled-components';

import media from '../../../../theme/media';

export const Container = styled.div`
    margin-bottom: ${(props) => (props.indentSmall ? '16px' : props.indentCompact ? '32px' : '48px')};

    ${media.desktop1920} {
        margin-bottom: ${(props) => (props.indentSmall ? '32px' : props.indentCompact ? '48px' : '72px')};
    }
`;
export const Title = styled.div`
    font-size: 24px;
    line-height: 36px;
    color: ${(props) => props.theme.black};
    text-align: ${(props) => (props.isCentered ? 'center' : '')};

    ${media.desktop1920} {
        font-size: 32px;
        line-height: 48px;
    }
`;
export const SubTitle = styled.div`
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => props.theme.grey_72_lc};
    margin-top: 16px;

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }

    ol {
        list-style: decimal inside;
    }
`;
export const RowButton = styled.div`
    margin-top: ${(props) => (props.addTopMargin ? '48px' : '4px')};

    ${media.tablet720} {
        margin-top: ${(props) => (props.addTopMargin ? '56px' : '4px')};
    }
`;
